import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { LibControlePerfModule, PipesModule } from '@estel-numerique/galaclick-core';
import { NgSelectModule } from '@ng-select/ng-select';
import { CtrlAccess } from '@services/util/ctrlAccess';


import { SharedModule } from 'src/app/shared.module';
import { CPerfEtatChampsService } from '../services/controle-perf/services/cperf-etat-champs.service';
import { FicheClientDetailsComponent } from './pages/ficheclient-details/ficheclient-details.component';
import { FicheClientDonneesGenComponent } from './pages/ficheclient-donneesgen/ficheclient-donneesgen.component';
import { FicheClientEngagementsComponent } from './pages/ficheclient-donneesgen/ficheclient-engagements/ficheclient-engagements.component';
import { FicheClientLaiteriesComponent } from './pages/ficheclient-donneesgen/ficheclient-laiteries/ficheclient-laiteries.component';
import { FicheClientGroupesComponent } from './pages/ficheclient-groupes/ficheclient-groupes.component';
import { FicheClientTechniquesComponent } from './pages/ficheclient-groupes/ficheclient-techniques/ficheclient-techniques.component';
import { FicheClientAteliersComponent } from './pages/ficheclient-races/ficheclient-ateliers/ficheclient-ateliers.component';
import { FicheClientRacesComponent } from './pages/ficheclient-races/ficheclient-races.component';
import { FicheClientCampagnesComponent } from './pages/ficheclient-surfaces/ficheclient-campagnes/ficheclient-campagnes.component';
import { FicheClientRfSurfaceComponent } from './pages/ficheclient-surfaces/ficheclient-campagnes/ficheclient-rfsurface.component';
import { FicheClientSurfacesComponent } from './pages/ficheclient-surfaces/ficheclient-surfaces.component';

@NgModule({
    imports: [
        NgSelectModule,
        CommonModule,
        PipesModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        DragDropModule,
        LibControlePerfModule,
        MatButtonModule,
        FicheClientDetailsComponent,
        FicheClientDonneesGenComponent,
        FicheClientLaiteriesComponent,
        FicheClientEngagementsComponent,
        FicheClientGroupesComponent,
        FicheClientTechniquesComponent,
        FicheClientSurfacesComponent,
        FicheClientCampagnesComponent,
        FicheClientRacesComponent,
        FicheClientAteliersComponent,
        FicheClientRfSurfaceComponent
    ],
    exports: [
        FicheClientDetailsComponent
    ],
    providers: [
        CtrlAccess,
        CPerfEtatChampsService,
    ],
    schemas: [NO_ERRORS_SCHEMA]
})
export class FicheClientModule {

}
